import BasicPage from './ComposedBasicPage';
import { BasicPageQuery } from './BasicPageQuery.graphql';

BasicPage.query = BasicPageQuery;

export default BasicPage;
